import React from "react";
import ReactDOM from "react-dom";
import EditHelper from "./index";
import Main from "./Main";

/* ReactDOM.render(<Main />, document.getElementById("root"));
 */
export default function MainEdit(props) {
    return (
        <>
            <EditHelper {...props} />
        </>
    )
} 